// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-photoprintpreviewmobile_container__1iczc","quantity":"idt-photoprintpreviewmobile_quantity__t6bfd"};